/* @flow */
import Vue from 'vue';
import Vuex from 'vuex';
import user from './modules/user' // 账号模块
import permission from './modules/permission' // 账号模块
import getters from './getters';


Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    user,
    permission
  },
  getters
});

export default store;
